// file_upload_controller.js
import { Controller } from "@hotwired/stimulus";
import { buildUploadHandler } from "../utils/cloudinary";
import { post } from "@rails/request.js";
import { emitContentMediaSelected } from "../utils/events";

export default class extends Controller {
  static targets = ["input", "bar", "dropzone"];
  static classes = ["dragging"];
  static values = {
    selectionArgs: Object, // arguments à renvoyer avec l'event pour l'identifier chez le récepteur
    origin: String,
    acceptVideo: Boolean,
    endpoint: String,
  };

  connect() {
    console.log(this.selectionArgsValue);
  }

  // Gestion des événements de drag & drop
  dragenter(event) {
    event.preventDefault();
    this.dragCounter = (this.dragCounter || 0) + 1;
    if (!this.uploadingValue) {
      this.dropzoneTarget.classList.add(...this.draggingClasses);
    }
  }

  dragleave(event) {
    event.preventDefault();
    this.dragCounter = (this.dragCounter || 1) - 1;
    if (this.dragCounter === 0 && !this.uploadingValue) {
      this.dropzoneTarget.classList.remove(...this.draggingClasses);
    }
  }

  dragover(event) {
    event.preventDefault();
  }

  drop(event) {
    event.preventDefault();
    this.dragCounter = 0;
    if (!this.uploadingValue) {
      this.dropzoneTarget.classList.remove(...this.draggingClasses);
      const files = event.dataTransfer.files;
      if (files.length > 0) {
        this.inputTarget.files = files;
        this.handleFiles(files);
      }
    }
  }

  // Gestion des fichiers sélectionnés via l'input
  change(event) {
    const files = this.inputTarget.files;
    if (files.length > 0) {
      this.handleFiles(files);
    }
  }

  // Traitement des fichiers sélectionnés
  handleFiles(files) {
    console.log(files.length);
    const filesArray = Array.from(files);
    let shouldUpload = true;

    // On bloque les fichiers qui ne respectent pas les formats autorisés
    filesArray.forEach((file) => {
      if (!this.acceptVideoValue && file.type.startsWith("video/")) {
        alert(
          "Les fichiers vidéos ne sont pas autorisés. Seuls les images sont autorisées au format suivants : png, jpg, jpeg, gif, webp et pdf."
        );
        shouldUpload = false;
      }
    });
    if (shouldUpload) {
      this.uploadToCloudinary(filesArray);
    }
  }

  async addFile(file) {
    const body = JSON.stringify({
      content_medium: {
        medium: file.identifier + "#" + file.signature,
      },
    });
    const res = await post(this.endpointValue, {
      body,
      headers: { Accept: "application/json" },
    });
    const json = await res.json;
    const { content_medium } = json;
    if (
      this.statuses &&
      Object.values(this.statuses).every((s) => s.status == "done")
    ) {
      this.terminateLoading();
    }
    emitContentMediaSelected(
      content_medium,
      this.originValue,
      this.selectionArgsValue
    );
    window.closeDialog(this.originValue);
  }

  // On retient les infos sur plusieurs uplaods en même temps et on retient le plus bas
  updateFileStatus(signature, status) {
    if (!this.statuses) {
      this.statuses = {};
      this.barTarget.classList.remove("hidden");
    }
    this.statuses[signature] = status;

    //const values = Object.values(this.statuses)
    const percent = Math.min(
      ...Object.values(this.statuses).map((s) => s.progress)
    );

    this.barTarget.style.width = `${percent}%`;

    // if (values.map(s => s.status).every(s => s == "done")) {
    //   setTimeout(() => {
    //     this.barTarget.classList.add('hidden')
    //     this.statuses = null
    //   }, 1000)
    // }
  }

  terminateLoading() {
    this.barTarget.classList.add("hidden");
    this.statuses = null;
  }

  get uploadToCloudinary() {
    return buildUploadHandler({
      addFile: this.addFile.bind(this),
      updateFileStatus: this.updateFileStatus.bind(this),
    });
  }

  // Formater la taille du fichier
  // formatFileSize(bytes) {
  //   if (bytes === 0) return '0 Bytes'
  //   const k = 1024
  //   const sizes = ['Bytes', 'KB', 'MB', 'GB']
  //   const i = Math.floor(Math.log(bytes) / Math.log(k))
  //   return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  // }
}
